import Loader from "components/shared/loader";
import TCLayout from "core/layouts/tc-layout/tc-layout";
import { useSelector } from "react-redux";
import { isInternalUser } from "utils/const";

function PrivateRoute({ permissionKey = "", isInternal = false, children }) {
  const userProfileData = useSelector((state) => state.profiledata.data);
  const userAccess = useSelector((state) => state.userAccess.accessKeys);
  const hasInternalAccess = isInternalUser(userProfileData?.email);
  const isAllowed = isInternal ? hasInternalAccess : !!userAccess?.[permissionKey];

  if (!userProfileData?.email || userAccess?.initialLoad) {
    return (
      <TCLayout>
        <Loader />
      </TCLayout>
    );
  } else if (isAllowed) {
    return children;
  } else {
    return (
      <TCLayout>
        <div className="tw-flex tw-items-center tw-justify-center tw-h-full">
          <div className="tw-text-center">
            <img width={650} height={650} src="https://res.cloudinary.com/drzta9shk/image/upload/q_auto/v1594848489/website/icons/No_data-cuate_1_qkn0d9.svg" alt="Trademo" />
            <div className="tw-text-[40px] tw-leading-none">Access Denied</div>
            <div className="tw-my-2 tw-text-heading-sm tw-max-w-[600px] tw-mx-auto">You do not have permission to view this page.</div>
          </div>
        </div>
      </TCLayout>
    );
  }
}

export default PrivateRoute;
